import * as React from "react";
import type { SVGProps } from "react";
const SvgAddressBookEmail = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.667 17.5H5a1.666 1.666 0 0 1-1.666-1.666V4.167A1.666 1.666 0 0 1 4.999 2.5H15a1.666 1.666 0 0 1 1.667 1.666v4.167M2.602 6.667h1.981M2.602 10h1.981M2.5 13.334h2.083"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.167 12.5v3.333c0 .92.746 1.667 1.666 1.667h5c.92 0 1.667-.747 1.667-1.667V12.5c0-.92-.746-1.667-1.667-1.667h-5c-.92 0-1.667.746-1.667 1.667"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m11.459 13.333 1.504.746a.83.83 0 0 0 .74 0l1.506-.746"
    />
  </svg>
);
export default SvgAddressBookEmail;
